<template>
  <div class="hello">
    <img :src="tipImg" alt style="width:100%" v-if="isWeixin" />
    <img :src="bgImg" class="bg-img" alt style="width:100%;" />
    <a href="https://onekeyserver.oss-cn-shenzhen.aliyuncs.com/apk/lechouhui.apk">
      <div class="button">乐筹汇APP下载（Android）</div>
    </a>
    <div class="cover" v-if="isWeixin" @touchmove.stop.prevent></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isWeixin: null,
      bgImg: require("../images/0609ADD3-2804-47E9-AE33-DECEAA63F694.png"),
      tipImg: require("../images/tips.png")
    };
  },

  created() {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      this.isWeixin = true;
    } else {
      this.isWeixin = false;
    }
  }
};
</script>

<style scoped lang="stylus">
.bg-img {
  display: block;
  margin-top: -10px;
}

a {
  color: #ffffff;
  text-decoration: none;

  .button {
    background-color: #33C759;
    letter-spacing: 1px;
    width: calc(100% - 60px);
    height: 45px;
    line-height: 45px;
    text-align: center;
    margin: 30px auto;
    border-radius: 3px;
  }
}

.cover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
}
</style>
